module.exports = __webpack_public_path__ + "img/google-logo.9dde0a44.png";